export {
  AccessControlProvider,
  Can,
  withAccessControl,
  useAccessControl,
  AccessControlContext,
} from '@ifb-b2b-iam/access-control';

export type { Namespace } from '@ifb-b2b-iam/access-control';
